import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { canAccess } from '../lib/permissions'

function Loading() {
  return (
    <div className="loading-page">
      <div className="spinner" />
      <p>Loading Kobflo Agri...</p>
    </div>
  )
}

// Basic auth protection
export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth()
  if (loading) return <Loading />
  if (!user) return <Navigate to="/login" replace />
  return children
}

// Section-level protection — checks role access
export function SectionRoute({ sectionId, children }) {
  const { user, profile, loading } = useAuth()
  if (loading) return <Loading />
  if (!user) return <Navigate to="/login" replace />
  if (!canAccess(profile, sectionId)) return <Navigate to="/dashboard" replace />
  return children
}

// Admin only
export function AdminRoute({ children }) {
  const { user, profile, loading } = useAuth()
  if (loading) return <Loading />
  if (!user) return <Navigate to="/login" replace />
  if (profile?.permission_level !== 'admin') return <Navigate to="/dashboard" replace />
  return children
}
